import { useState, useCallback } from "react";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import FinancialApplicationApiClient from "../api/financialApplicationApiClient";
import { RunSanctionsMatchRequestDTO } from "../types/RunSanctionsMatchRequestDTO";

interface RunSanctionsMatchResult {
  loading: boolean;
  error: string | null;
  runSanctionsMatch: (
    financialApplicationId: string,
    request: RunSanctionsMatchRequestDTO
  ) => Promise<void>;
}

export const useRunSanctionsMatch = (): RunSanctionsMatchResult => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const runSanctionsMatch = useCallback(
    async (financialApplicationId: string, request: RunSanctionsMatchRequestDTO) => {
      setLoading(true);
      setError(null);

      try {
        await financialApplicationApiClient.runSanctionsMatch(financialApplicationId, request);
      } catch (err) {
        console.error("Failed to run sanctions match:", err);
        setError(err instanceof Error ? err.message : "Failed to run sanctions match");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [financialApplicationApiClient]
  );

  return {
    loading,
    error,
    runSanctionsMatch,
  };
};
